﻿import { BaseResponse } from '../../../shared/models/base-response.model';

export class BookSlotResponse extends BaseResponse {
    public visitId: number;
    public hasPayment: boolean;
    public paymentUrl: string;
    public hasInvoiceData: boolean;
}